import { Box, Grid, Typography, Chip } from "@material-ui/core";
import { filterTableStrings } from "./StringBundle";
import { useGlobalStyles } from "./globalStyles";

function FilterChip({ filterSettings = [], clearFilterSettings }) {
  const globalClasses = useGlobalStyles();

  if (!filterSettings?.length) return null;

  return (
    <Box className={`${globalClasses.margins} ${globalClasses.pt10}`}>
      <Grid container className={globalClasses.displayctrl}>
        <Grid item>
          <Typography variant="body1" className={globalClasses.filterApplied}>
            {filterTableStrings.filterApplied}
          </Typography>
        </Grid>

        {filterSettings?.map((item, index) => (
          <Grid item key={index}>
            <Chip
              label={`${item?.searchedTitle}:  ${item?.searchText}`}
              onDelete={() => clearFilterSettings(index)}
              className={globalClasses.filterChip}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default FilterChip;
